import { request } from "../utils/request";
import { BACKEND_BASE_URL } from "./Resolver";

const API_URL = new URL(`${BACKEND_BASE_URL}/api/_meta`);

export class Meta {
  name: string;
  version: string;
  git_commit: string;
  build_time: string;
  application_region: string;

  constructor(
    name: string,
    version: string,
    git_commit: string,
    build_time: string,
    application_region: string,
  ) {
    this.name = name;
    this.version = version;
    this.git_commit = git_commit;
    this.build_time = build_time;
    this.application_region = application_region;
  }

  static async retrieve(): Promise<Meta> {
    const url = new URL(API_URL);
    const response = await request(url, { method: "GET" }, false);
    return await response.json();
  }
}
